// The plan vocabulary is owned by the backend's ONE catalog
// (products/diwa/src/diwa/entitlements.py): Keeper / Keeper Plus / Operator /
// Studio / Sovereign. /dashboard sends both the key and the display name; this
// helper prefers the server's name and only FORMATS a bare key as a fallback
// ("keeper_plus" → "Keeper Plus"). There is deliberately no mapping table here —
// a table is a second vocabulary waiting to drift (the P0-1 audit finding).

export function planLabel(key: string | null | undefined, name?: string | null): string {
  if (name) return name
  if (!key) return ''
  return key
    .split(/[_-]+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(' ')
}
